export function ConnectGuideMacos() {
  return (
    <svg viewBox="0 0 240 200" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-xs mx-auto block" aria-hidden="true">
      {/* Menu bar */}
      <rect x="4" y="4" width="232" height="22" fill="#ececec" />
      <text x="14" y="18" fontSize="11" fontWeight="700" fill="#000000">&#63743;</text>
      <text x="36" y="18" fontSize="10" fill="#000000">Finder</text>
      {/* WLAN icon highlighted */}
      <rect x="180" y="4" width="24" height="22" fill="#0071e3" opacity="0.15" rx="2" />
      <text x="192" y="18" textAnchor="middle" fontSize="12" fill="#000000">📶</text>
      {/* Dropdown panel */}
      <rect x="140" y="26" width="96" height="170" rx="8" fill="#f5f5f5" stroke="#c0c0c0" strokeWidth="0.5" />
      {/* Panel header */}
      <text x="188" y="44" textAnchor="middle" fontSize="10" fontWeight="600" fill="#333">WLAN</text>
      <line x1="148" y1="50" x2="228" y2="50" stroke="#d0d0d0" strokeWidth="0.5" />
      {/* Preferred networks */}
      <text x="152" y="64" fontSize="9" fill="#666">BEVORZUGTE NETZWERKE</text>
      {/* Network 1 highlighted */}
      <rect x="144" y="68" width="88" height="28" rx="4" fill="#0071e3" />
      <text x="162" y="82" fontSize="11" fill="#ffffff">Dein-WLAN</text>
      <text x="162" y="92" fontSize="8" fill="#c0d8ff">✓ Verbunden</text>
      <line x1="148" y1="100" x2="228" y2="100" stroke="#d0d0d0" strokeWidth="0.3" />
      {/* Network 2 */}
      <rect x="144" y="104" width="88" height="24" rx="4" fill="transparent" />
      <text x="162" y="118" fontSize="11" fill="#333">Dein-WLAN-5G</text>
      <line x1="148" y1="132" x2="228" y2="132" stroke="#d0d0d0" strokeWidth="0.3" />
      <rect x="144" y="136" width="88" height="24" rx="4" fill="transparent" />
      <text x="162" y="150" fontSize="11" fill="#333">Gäste-WLAN</text>
      <line x1="148" y1="164" x2="228" y2="164" stroke="#d0d0d0" strokeWidth="0.3" />
      {/* Arrow from menu bar icon to panel */}
      <polygon points="192,26 185,14 199,14" fill="#0071e3" />
    </svg>
  );
}
